// extracted by mini-css-extract-plugin
export default {"logout__wrapper":"Logout_logout__wrapper__v9uQJ","logout":"Logout_logout__bgAoR"};